__turbopack_context__.v({
  "resetButton": "TypeLink-module-scss-module__b1UZUG__resetButton",
  "typeWithHint": "TypeLink-module-scss-module__b1UZUG__typeWithHint",
});
